import type { App } from 'vue'
import AppImageCropper from './app-image-cropper.vue'
import AppImageCropper2 from './app-image-cropper-2.vue'
import AppImageInput from './app-image-input.vue'
import AppImageInput2 from './app-image-input-2.vue'

export default {
  install (app: App) {
    app.component('AppImageInput', AppImageInput)
    app.component('AppImageCropper', AppImageCropper)
    app.component('AppImageInput2', AppImageInput2)
    app.component('AppImageCropper2', AppImageCropper2)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppImageInput: typeof AppImageInput,
    AppImageCropper: typeof AppImageCropper,
    AppImageInput2: typeof AppImageInput2,
    AppImageCropper2: typeof AppImageCropper2,
  }
}
